import API from '../../../../services/api-middleware';
import {
  AwsSelected,
  createOrEditFolderProp,
  EditFile,
  FolderQueryParams,
  TableFunctions,
} from '../kb.props';

const baseUrl = process.env.REACT_APP_LLM_SERVER_URL;
const appBaseUrl = process.env.REACT_APP_USER_SERVER_URL;
// CREATE FOLDER
export const createFolder = async (payload: createOrEditFolderProp) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`knowledge-base`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// ALL FOLDERS
export const listAllFolder = async (payload: FolderQueryParams) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const encodedFilters = encodeURIComponent(JSON.stringify(payload.filters));
    const response = await API(baseUrl).get(
      `knowledge-base?limit=${payload.limit}&offset=${payload.offset}&search=${payload.search}&filters=${encodedFilters}&service=${payload.service}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// ALL PUBLIC FOLDERS
export const listAllPublicFolder = async (payload: FolderQueryParams) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const encodedFilters = encodeURIComponent(JSON.stringify(payload.filters));
    const response = await API(baseUrl).get(
      `knowledge-base/public?limit=${payload.limit}&offset=${payload.offset}&search=${payload.search}&filters=${encodedFilters}&service=${payload.service}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// SHARE FOlDER
export const shareCreatedFolder = async (payload: { id: number }) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`knowledge-base/public`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// EDIT FOLDER
export const editCreatedFolder = async (payload: createOrEditFolderProp) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).put(`knowledge-base`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// DELETE FOLDER
export const deleteFolder = async (id: number) => {
  const data = {
    id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(`knowledge-base`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// UPLOAD FILE TO A PARTICULAR FOLDER
export const uploadFileToFolder = async (payload: FormData, folderId: number) => {
  let token = localStorage.getItem('token');
  if (token !== null) {
    token = JSON.parse(token);
  }
  try {
    const response = await API(baseUrl).post(`knowledge-base/store/${folderId}/file`, payload, {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// UPLOADED FILES FOR THE PARTICULAR FOLDER
export const fileForParticularFolder = async (payload: TableFunctions, folderId: number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const encodedFilters = encodeURIComponent(JSON.stringify(payload.filters));
    const response = await API(baseUrl).get(
      `knowledge-base/store/${folderId}/file?limit=${payload.limit}&offset=${payload.offset}&search=${payload.search}&sort_col=${payload.sort_col}&sort_order=${payload.sort_order}&filters=${encodedFilters}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// DELETE FILE
export const deleteFile = async (folderId: number, id: Array<number>) => {
  const data = {
    ids: id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(`knowledge-base/store/${folderId}/file`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// TO DOWNLOAD A FILE
export const downloadFile = async (fileId: number, folderId: number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `knowledge-base/store/${folderId}/file/${fileId}/download`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// TO EDIT FILE NAME
export const editFileName = async (folderId: number, payload: EditFile) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).put(`knowledge-base/store/${folderId}/file`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getKbGDriveFoldersById = async (folderId: string | number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`/drive-folders/${folderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getKbAwsFoldersById = async (folderId: string | number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`/aws-buckets/${folderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getKbGDriveFoldersContentById = async (
  StoreId: number | string,
  folderId: string | number,
) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`/drive-folders/${StoreId}/contents/${folderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getKbAwsFoldersContentById = async (
  storeId: number | string,
  payload: { prefix: string | undefined; bucket_name: string | undefined },
) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }

    const encodedBucketName = payload.bucket_name ? encodeURIComponent(payload.bucket_name) : '';
    const encodedPrefix = payload.prefix ? encodeURIComponent(payload.prefix) : '';

    const response = await API(baseUrl).get(
      `/aws-s3-folders/${storeId}/contents?bucket_name=${encodedBucketName}&prefix=${encodedPrefix}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCredential = async (service: string, folderId: string | number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(appBaseUrl).get(`/credentials/${service}/${folderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCredential = async (credentialId: number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const data = {
      id: credentialId,
    };

    const response = await API(appBaseUrl).delete('/credentials', {
      data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAwsAuthentication = async (
  folderId: number,
  payload: { access_key: string; secret_key: string },
) => {
  try {
    const data = {
      access_key: payload.access_key,
      secret_key: payload.secret_key,
    };
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(appBaseUrl).post(`/aws-login/${folderId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getGoogleAuthentication = (folderId: number, userId: number) => {
  const authUrl = `${appBaseUrl}/google-login/${folderId}/${userId}`;
  const width = 500;
  const height = 600;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  const popup = window.open(
    authUrl,
    'GoogleAuthPopup',
    `width=${width},height=${height},left=${left},top=${top}`,
  );

  if (!popup) {
    throw new Error('Popup was blocked. Please enable popups for this site.');
  }

  const receiveMessage = (event: MessageEvent) => {
    if (event.origin !== authUrl) return;
    const { token } = event.data;
    if (token) {
      popup.close();
      window.removeEventListener('message', receiveMessage);
      const params = new URLSearchParams(window.location.search);
      params.set('authenticationSuccess', 'true');
      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    }
  };

  window.addEventListener('message', receiveMessage);
};

export const GetAuthenticateWithExitingCred = async (storeID: number, CredentialId: number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(appBaseUrl).post(
      `/knowledge-base/${storeID}/update-credentials/${CredentialId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const UploadDriveFolders = async (
  storeID: number,
  payload: {
    folderIds: string[];
    chunkSize: number;
    chunkOverlap: number;
  },
) => {
  const data = {
    folder_ids: payload.folderIds,
    chunk_size: payload.chunkSize,
    chunk_overlap: payload.chunkOverlap,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`/drive-folders/upload/${storeID}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const UploadAwsS3Folders = async (
  storeID: number,
  payload: {
    buckets: AwsSelected[];
    chunkSize: number;
    chunkOverlap: number;
  },
) => {
  const data = {
    buckets: payload.buckets,
    chunk_size: payload.chunkSize,
    chunk_overlap: payload.chunkOverlap,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`/aws-s3/upload/${storeID}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getReSync = async (folderId: string | number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`/knowledge-base/resync/${folderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getKbAwsCredentials = async (payload: number[]) => {
  const data = {
    ids: payload,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`/knowledge-base/upload/status`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getKbFolders = async (folderId: number | string) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`/knowledge-base/folders/${folderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
